export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./RichHorizontalIndicator.vue?vue&type=template&id=fbb292f0&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./src/vuestic-theme/vuestic-components/vuestic-wizard/indicators/RichHorizontalIndicator.vue?vue&type=template&id=fbb292f0&scoped=true
// module id = bver
// module chunks = 41